import { render } from "./chatLeftList.vue?vue&type=template&id=2ed26bff&scoped=true"
import script from "./chatLeftList.vue?vue&type=script&lang=js"
export * from "./chatLeftList.vue?vue&type=script&lang=js"

import "./chatLeftList.vue?vue&type=style&index=0&id=2ed26bff&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/aikangmall-im-seller/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed26bff"]])

export default __exports__